import { Design_ } from 'src/api/db/apiDesigns'

export const getFilterStyle = (design: Partial<Design_>) => {
  const { brightness, saturation, hue, colorFilter } = design
  let filter = ''

  // Handle color filter options
  if (colorFilter === 'black') {
    filter += 'brightness(0) saturate(100%) '
  } else if (colorFilter === 'white') {
    filter += 'brightness(0) invert(1) '
  }

  if (brightness !== undefined && brightness !== null) {
    filter += `brightness(${brightness}%) `
  }
  if (saturation !== undefined && saturation !== null) {
    filter += `saturate(${saturation}%) `
  }
  if (hue !== undefined && hue !== null) {
    filter += `hue-rotate(${hue}deg) `
  }

  return filter.trim() || 'none'
}
